import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NavigationComponent} from '../shared/components';
import {SearchResultsComponent} from './components/search-results/search-results.component';
import {LoggedInGuard} from '../../core/guards/logged-in.guard';

const routes: Routes = [{
  path: '',
  children: [
    {path: '', canActivate: [LoggedInGuard], component: SearchResultsComponent},
  ]
},
  {path: '', component: NavigationComponent, outlet: 'navigation'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchFilterRoutingModule {
}
